import {
  Modal,
  FormControl,
  Glyphicon,
  Tooltip,
  OverlayTrigger
} from 'react-bootstrap'
import Button from 'components/Button'
import styled from 'styled-components'

const ModalBody = styled(Modal.Body)`
  text-align: center;
  input {
    margin-bottom: 15px;
  }
`

const EmailButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  color: var(--main-color);
  padding: 0;
  margin: 0;
  font-size: 16px;

  .glyphicon {
    vertical-align: middle;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    color: var(--dark-gray);
    opacity: 0.7;
  }
`

const ContentMailer = ({
  email,
  showModal,
  handleSubmit,
  error,
  isFetching,
  openModal,
  closeModal,
  handleChange,
  disabled,
  nameInputValue,
  name,
  careAssistEmail
}) => {
  const tooltip = (
    <Tooltip id="tooltip">
      {!disabled && <>Send solution to email</>}
      {disabled && <>Private articles cannot be shared</>}
    </Tooltip>
  )

  return (
    <span>
      <OverlayTrigger placement="top" overlay={tooltip}>
        <span>
          &nbsp;
          <EmailButton onClick={openModal} disabled={disabled}>
            <Glyphicon glyph="envelope" />
          </EmailButton>
        </span>
      </OverlayTrigger>
      <Modal show={showModal} onHide={closeModal} bsSize="small">
        <Modal.Header closeButton>
          <Modal.Title>Send solution to email</Modal.Title>
        </Modal.Header>
        <ModalBody>
          <form onSubmit={handleSubmit}>
            {error && <div className="text-danger">{error}</div>}

            <FormControl
              disabled={isFetching}
              value={email}
              placeholder="Email"
              onChange={handleChange}
            />
            {careAssistEmail && careAssistEmail.includes('{name}') && (
              <FormControl
                disabled={isFetching}
                value={name}
                placeholder="Customer Name (optional)"
                onChange={nameInputValue}
              />
            )}

            <Button primary disabled={isFetching}>
              Send
            </Button>
          </form>
        </ModalBody>
      </Modal>
    </span>
  )
}

export default ContentMailer
